import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["checked", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "toggle__label"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'checkbox',
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean, default: false },
    label: { default: '' }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

function onChange(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
  emit('change', target.checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["toggle", {
      'toggle--checked': __props.modelValue,
      'toggle--disabled': __props.disabled
    }])
  }, [
    _createElementVNode("input", {
      class: "toggle__input",
      type: "checkbox",
      checked: __props.modelValue,
      disabled: __props.disabled,
      onChange: onChange
    }, null, 40, _hoisted_1),
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "toggle__track" }, [
      _createElementVNode("span", { class: "toggle__thumb" })
    ], -1))
  ], 2))
}
}

})